import { ConfigOptions, download, generateCsv, mkConfig } from 'export-to-csv'
import { AcceptedData } from 'node_modules/export-to-csv/output/lib/types'

export type ColumnHeader =
  | string
  | {
      key: string
      displayLabel: string
    }

export type CSVPropertyData = { [key: string]: unknown }[] | (string | number | null)[][]

const downloadCSV = (
  options: ConfigOptions,
  data: CSVPropertyData,
  headers?: ColumnHeader[]
): void => {
  const csvConfig = mkConfig({
    columnHeaders: headers,
    filename: options.filename
  })
  const csv = generateCsv(csvConfig)(data as { [key: string]: AcceptedData }[])
  download(csvConfig)(csv)
}

export default downloadCSV
